import { BasicCostDetail, mapBasicCostDetail } from "./BasicCostDetail";
import { FinanceCost, mapFinanceCost } from "./FinanceCost";
import { GDVCost, mapGDVCosts } from "./GDVCost";
import { LandCost, mapLandCost } from "./LandCost";
import { mapOtherCosts, OtherCost } from "./OtherCost";

export interface DevelopmentAppraisalDataList {
    id?: number;
    folder_id?: number;
    development_appraisal_id?: number;
    amount?: number;
    development_appraisal_gdv_sum_total_price?: number | null;
    development_appraisal_other_sum_amount?: number | null;
    development_appraisal_finance_cost_sum_finance_amount?: number | null;
    development_appraisal_land_cost_sum_purchase_price?: number | null;
    development_appraisal?: BasicCostDetail|null;
    development_appraisal_gdv?: GDVCost[];
    development_appraisal_other?: OtherCost[];
    development_appraisal_finance_cost?: FinanceCost | null;
    development_appraisal_land_cost?: LandCost | null;
}

// to single object maping
export const mapDevelopmentAppraisalDataList = (data:any): DevelopmentAppraisalDataList => {
    if(!data){
        throw new Error('Invalid Data')
    }
    const  res: DevelopmentAppraisalDataList ={
        id: data.id,
        folder_id: data.folder_id,
        development_appraisal_id: data.development_appraisal_id,
        amount: data.amount,
        development_appraisal_gdv_sum_total_price: data.development_appraisal_gdv_sum_total_price,
        development_appraisal_other_sum_amount: data.development_appraisal_other_sum_amount,
        development_appraisal_finance_cost_sum_finance_amount: data.development_appraisal_finance_cost_sum_finance_amount,
        development_appraisal_land_cost_sum_purchase_price: data.development_appraisal_land_cost_sum_purchase_price,
        development_appraisal:(data.development_appraisal!==null)? mapBasicCostDetail(data.development_appraisal):null,
        development_appraisal_gdv: mapGDVCosts(data.development_appraisal_gdv),
        development_appraisal_other:mapOtherCosts(data.development_appraisal_other) ,
        development_appraisal_finance_cost:(data.development_appraisal_finance_cost!==null)? mapFinanceCost(data.development_appraisal_finance_cost):null ,
        development_appraisal_land_cost:(data.development_appraisal_land_cost!==null)? mapLandCost(data.development_appraisal_land_cost):null ,
    }
    return res;
}

// maping list objects
export const mapDevelopmentAppraisalDataLists = (data:any[]): DevelopmentAppraisalDataList[] => {
     if (!Array.isArray(data)) {
       throw new Error('Invalid Data');
     }
     return data.map(mapDevelopmentAppraisalDataList);
}
